import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4071c7f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row justify-content-between align-items-center h-100" }
const _hoisted_2 = { class: "d-flex flex-row align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-logo mx-2",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"justify-content":"center"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nav-title d-none d-sm-inline" }, "QRcode 門禁系統")
], -1))
const _hoisted_5 = { class: "d-flex flex-row align-items-center h-100 me-sm-0 me-md-2" }
const _hoisted_6 = { class: "d-none d-sm-inline me-3" }
const _hoisted_7 = { class: "icon-wrap icon-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 繁體中文 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hamburger icon-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('OnHamburgerClicked')))
      }, [
        _createVNode(_component_ion_icon, {
          icon: _ctx.menuOutline,
          style: {"font-size":"1.6rem"}
        }, null, 8, ["icon"])
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "icon-wrap mx-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLogoutClicked && _ctx.onLogoutClicked(...args)))
      }, [
        _createVNode(_component_ion_icon, {
          icon: _ctx.personCircleOutline,
          style: {"font-size":"26px"},
          title: "account"
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userInfoStore.displayName), 1),
      _createVNode(_component_el_tooltip, {
        content: "Language",
        placement: "bottom",
        effect: "light",
        disabled: _ctx.langTooltipDisabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            class: "d-flex align-items-center mx-1"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onLangSelectChanged(_ctx.LocaleType.en_us)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onLangSelectChanged(_ctx.LocaleType.zh_tw)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ion_icon, {
                  icon: _ctx.globeOutline,
                  style: {"font-size":"25px"}
                }, null, 8, ["icon"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_tooltip, {
        content: _ctx.t('sign_out'),
        placement: "bottom",
        effect: "light"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "icon-wrap icon-btn mx-1",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onLogoutClicked && _ctx.onLogoutClicked(...args)))
          }, [
            _createVNode(_component_ion_icon, {
              icon: _ctx.logOutOutline,
              style: {"font-size":"28px"}
            }, null, 8, ["icon"])
          ])
        ]),
        _: 1
      }, 8, ["content"])
    ])
  ]))
}